var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"resize",staticStyle:{"border":"0px solid gray","margin":"0px","padding":"0px","text-align":"center"},style:({ height: _vm.height}),attrs:{"id":_vm.divName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }